module.exports = __webpack_public_path__ + "img/puree.d3da396d.jpg";